import { NgModule } from '@angular/core';
import { MeQuickTestComponent } from './quick-test.component';
import { BaseModule } from '../../shared/base.module';
import { StoryBlokLinkModule } from '../../shared/storyblok/link/link.module';
import { MeQuickTestRoutesModule } from './quick-test.routes';
import { MatSliderModule } from '@angular/material/slider';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MeQuickTestResultComponent } from './result/quick-test-result.component';
import { MeQuickTestHelpCardComponent } from './help-card/help-card.component';

@NgModule({
    imports: [
        BaseModule,
        MatSliderModule,
        ModalModule.forRoot(),
        MeQuickTestRoutesModule,
        StoryBlokLinkModule
    ],
    declarations: [
        MeQuickTestHelpCardComponent,
        MeQuickTestResultComponent,
        MeQuickTestComponent
    ],
    exports: [
        MeQuickTestHelpCardComponent,
        MeQuickTestResultComponent,
        MeQuickTestComponent
    ]
})
export class MeQuickTestModule { }
